var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("订单管理")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("异常订单")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "div",
            { staticClass: "eltabs" },
            [
              _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.tabName,
                    callback: function ($$v) {
                      _vm.tabName = $$v
                    },
                    expression: "tabName",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: { label: "全部订单", name: "0" },
                  }),
                  _c("el-tab-pane", { attrs: { name: "1" } }, [
                    _c(
                      "span",
                      { attrs: { slot: "label" }, slot: "label" },
                      [
                        _vm.$store.getters.orderCount &&
                        _vm.$store.getters.orderCount.reject
                          ? _c(
                              "el-badge",
                              {
                                attrs: {
                                  value: _vm.$store.getters.orderCount.reject,
                                },
                              },
                              [_vm._v(" 拒收中 ")]
                            )
                          : _c("span", [_vm._v("拒收中")]),
                      ],
                      1
                    ),
                  ]),
                  _c("el-tab-pane", { attrs: { name: "2" } }, [
                    _c(
                      "span",
                      { attrs: { slot: "label" }, slot: "label" },
                      [
                        _vm.$store.getters.orderCount &&
                        _vm.$store.getters.orderCount.returnOfGoods
                          ? _c(
                              "el-badge",
                              {
                                attrs: {
                                  value:
                                    _vm.$store.getters.orderCount.returnOfGoods,
                                },
                              },
                              [_vm._v(" 退货中 ")]
                            )
                          : _c("span", [_vm._v("退货中")]),
                      ],
                      1
                    ),
                  ]),
                  _c("el-tab-pane", { attrs: { name: "3" } }, [
                    _c(
                      "span",
                      { attrs: { slot: "label" }, slot: "label" },
                      [
                        _vm.$store.getters.orderCount.beReturned
                          ? _c(
                              "el-badge",
                              {
                                attrs: {
                                  value:
                                    _vm.$store.getters.orderCount.beReturned,
                                },
                              },
                              [_vm._v(" 被退货中 ")]
                            )
                          : _c("span", [_vm._v("被退货中")]),
                      ],
                      1
                    ),
                  ]),
                  _c("el-tab-pane", { attrs: { label: "已完成", name: "4" } }),
                  _c("el-tab-pane", { attrs: { label: "已关闭", name: "5" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-collapse-transition", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.show3,
                    expression: "!show3",
                  },
                ],
                staticClass: "search",
              },
              [
                _c("div", { staticClass: "header" }, [
                  _c("span", [_vm._v("查询客户")]),
                  _c(
                    "p",
                    {
                      on: {
                        click: function ($event) {
                          _vm.show3 = true
                        },
                      },
                    },
                    [_vm._v("收起")]
                  ),
                ]),
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      inline: true,
                      model: _vm.queryForm,
                      "label-width": "",
                      size: "mini",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "客户信息" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入客户手机号码/姓名" },
                          model: {
                            value: _vm.queryForm.info,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "info", $$v)
                            },
                            expression: "queryForm.info",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "原单编号" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入原单编号" },
                          model: {
                            value: _vm.queryForm.orderId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "orderId", $$v)
                            },
                            expression: "queryForm.orderId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "订单编号" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入订单编号" },
                          model: {
                            value: _vm.queryForm.orderCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "orderCode", $$v)
                            },
                            expression: "queryForm.orderCode",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "部门选择" } },
                      [
                        _c("el-cascader", {
                          attrs: {
                            options: _vm.options,
                            props: {
                              checkStrictly: true,
                              label: "orgName",
                              value: "orgPath",
                              children: "children",
                            },
                            clearable: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.queryForm.orgName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "orgName", $$v)
                            },
                            expression: "queryForm.orgName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "客服" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择客服",
                              filterable: "",
                              clearable: "",
                              "default-first-option": "",
                            },
                            model: {
                              value: _vm.queryForm.service,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "service", $$v)
                              },
                              expression: "queryForm.service",
                            },
                          },
                          _vm._l(_vm.customer, function (items) {
                            return _c("el-option", {
                              key: items.id,
                              attrs: {
                                label: items.reallyName,
                                value: items.id,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "订单状态" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "选择订单状态",
                              filterable: "",
                              clearable: "",
                              "default-first-option": "",
                            },
                            model: {
                              value: _vm.queryForm.state,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "state", $$v)
                              },
                              expression: "queryForm.state",
                            },
                          },
                          _vm._l(_vm.status, function (itemsS) {
                            return _c("el-option", {
                              key: itemsS.dictId,
                              attrs: {
                                label: itemsS.dictName,
                                value: itemsS.dictId,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "selectDate" }, [
                      _c("span", [_vm._v("时间")]),
                      _c(
                        "div",
                        { staticClass: "picker" },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "daterange",
                              "unlink-panels": "",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              format: "yyyy- MM- dd",
                              "value-format": "yyyy-MM-dd",
                            },
                            model: {
                              value: _vm.queryForm.date,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "date", $$v)
                              },
                              expression: "queryForm.date",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.searchEvent.apply(null, arguments)
                          },
                          click: _vm.searchEvent,
                        },
                      },
                      [_vm._v("搜索")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.reset()
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "btnbox" },
            [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.$refs.xtable.setAllRowExpand(true)
                        },
                      },
                    },
                    [_vm._v("展开")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$refs.xtable.clearRowExpand()
                        },
                      },
                    },
                    [_vm._v("收起")]
                  ),
                ],
                1
              ),
              _vm.show3
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function ($event) {
                          _vm.show3 = false
                        },
                      },
                    },
                    [_vm._v("搜索展开")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "table" },
            [
              _c(
                "vxe-table",
                {
                  ref: "xtable",
                  attrs: {
                    "sync-resize": "",
                    data: _vm.tableData.list,
                    "expand-config": { expandAll: true },
                    "sort-config": { trigger: "cell" },
                    align: "center",
                  },
                  on: {
                    "checkbox-all": _vm.selectAllEvent,
                    "checkbox-change": _vm.selectChangeEvent,
                  },
                },
                [
                  _c("vxe-table-column", {
                    attrs: { type: "checkbox", width: "80" },
                  }),
                  _c("vxe-table-column", {
                    attrs: { type: "seq", title: "序号", width: "55" },
                  }),
                  _c("vxe-table-column", {
                    attrs: { type: "expand" },
                    scopedSlots: _vm._u([
                      {
                        key: "content",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "div",
                              { staticClass: "product" },
                              [
                                _c("p", [_vm._v("商品")]),
                                _c(
                                  "el-table",
                                  {
                                    attrs: {
                                      data: row.orderReturnCommodityList,
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: { prop: "brand", label: "品牌" },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "commodityName",
                                        label: "商品名称",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "originalNumber",
                                        label: "原单数量",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "number",
                                        label: "退货数量",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: { label: "仓库收货" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (prop) {
                                              return [
                                                _c(
                                                  "div",
                                                  { staticClass: "scope" },
                                                  [
                                                    _c("p", [
                                                      _vm._v(
                                                        "正常:" +
                                                          _vm._s(
                                                            prop.row.receivedNo
                                                          )
                                                      ),
                                                    ]),
                                                    _c("p", [
                                                      _vm._v(
                                                        "破损:" +
                                                          _vm._s(
                                                            prop.row.destroyNo
                                                          )
                                                      ),
                                                    ]),
                                                    _c("p", [
                                                      _vm._v(
                                                        "漏件:" +
                                                          _vm._s(
                                                            prop.row.brokenNo
                                                          )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: { prop: "price", label: "单价" },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "specificationName",
                                        label: "规格",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "total",
                                        label: "退货小计",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                !_vm.is_null(row.orderReturnComplimentaryList)
                                  ? _c("p", [_vm._v("赠品")])
                                  : _vm._e(),
                                !_vm.is_null(row.orderReturnComplimentaryList)
                                  ? _c(
                                      "el-table",
                                      {
                                        attrs: {
                                          data: row.orderReturnComplimentaryList,
                                        },
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "brand",
                                            label: "品牌",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "complimentaryName",
                                            label: "赠品名称",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "originalNumber",
                                            label: "原单数量",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "number",
                                            label: "退货数量",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: { label: "仓库收货" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (prop) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      { staticClass: "scope" },
                                                      [
                                                        _c("p", [
                                                          _vm._v(
                                                            "正常:" +
                                                              _vm._s(
                                                                prop.row
                                                                  .receivedNo
                                                              )
                                                          ),
                                                        ]),
                                                        _c("p", [
                                                          _vm._v(
                                                            "破损:" +
                                                              _vm._s(
                                                                prop.row
                                                                  .destroyNo
                                                              )
                                                          ),
                                                        ]),
                                                        _c("p", [
                                                          _vm._v(
                                                            "漏件:" +
                                                              _vm._s(
                                                                prop.row
                                                                  .brokenNo
                                                              )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "price",
                                            label: "单价",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "specificationName",
                                            label: "规格",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "total",
                                            label: "退货小计",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      title: "编号",
                      field: "originalOrderId",
                      "min-width": "200",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (prop) {
                          return [
                            _c("div", { staticClass: "scope" }, [
                              _c("p", [
                                _vm._v(
                                  "原单编号:" + _vm._s(prop.row.originalOrderId)
                                ),
                              ]),
                              _c("p", [
                                _vm._v("订单编号:" + _vm._s(prop.row.orderId)),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-table-column", {
                    attrs: { title: "客户", field: "", "min-width": "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (prop) {
                          return [
                            _c("div", { staticClass: "scope" }, [
                              _c("p", [_vm._v(_vm._s(prop.row.customerName))]),
                              _c("p", [_vm._v(_vm._s(prop.row.customerPhone))]),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-table-column", {
                    attrs: { title: "订单状态", "min-width": "140" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (prop) {
                          return [
                            _c("div", { staticClass: "scope" }, [
                              _c("p", [
                                _vm._v(_vm._s(prop.row.orderStatusName)),
                              ]),
                              _c("p", [
                                _vm._v("申请人：" + _vm._s(prop.row.applyName)),
                              ]),
                              _vm.tabName == 2
                                ? _c("p", [
                                    _vm._v(
                                      "销售：" + _vm._s(prop.row.applyName)
                                    ),
                                  ])
                                : _c("p", [
                                    _vm._v(
                                      "销售：" + _vm._s(prop.row.createdName)
                                    ),
                                  ]),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-table-column", {
                    attrs: { title: "金额", "min-width": "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (prop) {
                          return [
                            _c("div", { staticClass: "scope" }, [
                              _c("p", [
                                _vm._v("成交:" + _vm._s(prop.row.orderMoney)),
                              ]),
                              _c("p", [
                                _vm._v(
                                  "应退:" + _vm._s(prop.row.shouldReturnMoney)
                                ),
                              ]),
                              _c("p", [
                                _vm._v("实退:" + _vm._s(prop.row.returnMoney)),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-table-column", {
                    attrs: { title: "包裹单号", "min-width": "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (prop) {
                          return [
                            !_vm.is_null(prop.row.logisticsCompany)
                              ? _c("div", { staticClass: "scope" }, [
                                  _c("p", [
                                    _vm._v(_vm._s(prop.row.logisticsCompany)),
                                  ]),
                                  _c("p", [
                                    _vm._v(_vm._s(prop.row.parcelNumber)),
                                  ]),
                                ])
                              : _c("div", { staticClass: "scope" }, [
                                  _c("p", [_vm._v("— —")]),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-table-column", {
                    attrs: { title: "仓库收货", "min-width": "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (prop) {
                          return [
                            _c("div", { staticClass: "scope" }, [
                              _c("p", [
                                _vm._v("正常:" + _vm._s(prop.row.returnTotal)),
                              ]),
                              _c("p", [
                                _vm._v("破损:" + _vm._s(prop.row.destroyTotal)),
                              ]),
                              _c("p", [
                                _vm._v("漏件:" + _vm._s(prop.row.brokenTotal)),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      title: "收货信息",
                      "show-overflow": "",
                      "min-width": "160",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (prop) {
                          return [
                            _c("div", { staticClass: "scope" }, [
                              _c("p", [
                                _vm._v(
                                  _vm._s(prop.row.addressName) +
                                    " " +
                                    _vm._s(prop.row.addressPhone)
                                ),
                              ]),
                              _c("p", [_vm._v(_vm._s(prop.row.address))]),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm.tabName == 1
                    ? _c("vxe-table-column", {
                        attrs: { title: "拒收时间", width: "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c("p", [
                                    _vm._v(_vm._s(props.row.applyTime)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4226331547
                        ),
                      })
                    : _vm._e(),
                  _vm.tabName != 1
                    ? _c("vxe-table-column", {
                        attrs: { title: "时间", width: "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c("p", [
                                    _vm._v(_vm._s(props.row.applyTime)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4226331547
                        ),
                      })
                    : _vm._e(),
                  _c("vxe-table-column", {
                    attrs: { title: "操作", "min-width": "140" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (props) {
                          return [
                            _vm.tabName == 0
                              ? _c(
                                  "div",
                                  { staticClass: "operation" },
                                  [
                                    _vm._l(
                                      props.row.operatingStatus,
                                      function (items) {
                                        return _c(
                                          "div",
                                          {
                                            key: items,
                                            staticClass: "inlineDiv",
                                          },
                                          [
                                            props.row.exType == 1 &&
                                            props.row.orderType == 0 &&
                                            items == 3 &&
                                            _vm.parArray.indexOf(
                                              "returendeTrueCode"
                                            ) != -1
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.returningTrue(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 确认 ")]
                                                )
                                              : _vm._e(),
                                            props.row.exType == 1 &&
                                            props.row.orderType == 1 &&
                                            items == 2 &&
                                            _vm.parArray.indexOf(
                                              "returendeTrueCode"
                                            ) != -1
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.todetail(
                                                          props.row,
                                                          1
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 修改 ")]
                                                )
                                              : _vm._e(),
                                            props.row.exType == 1 &&
                                            props.row.orderType == 1 &&
                                            items == 1 &&
                                            _vm.parArray.indexOf(
                                              "returendeTrueCode"
                                            ) != -1
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.staffTrue(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 确认 ")]
                                                )
                                              : _vm._e(),
                                            props.row.exType == 1 &&
                                            props.row.orderType == 1 &&
                                            _vm.parArray.indexOf(
                                              "returendeTrueCode"
                                            ) != -1 &&
                                            items == 1
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.returningTrue(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 确认 ")]
                                                )
                                              : _vm._e(),
                                            _vm.parArray.indexOf(
                                              "approvalBtnCode"
                                            ) != -1 && items == 3
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.approvalBtn(
                                                          props.row,
                                                          1
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 批准 ")]
                                                )
                                              : _vm._e(),
                                            _vm.parArray.indexOf(
                                              "backReturning"
                                            ) != -1 && items == 3
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.approvalBtn(
                                                          props.row,
                                                          2
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 驳回 ")]
                                                )
                                              : _vm._e(),
                                            props.row.exType == 0 &&
                                            items == 1 &&
                                            _vm.parArray.indexOf("unFixCode") !=
                                              -1
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.todetail(
                                                          props.row,
                                                          1
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 修改 ")]
                                                )
                                              : _vm._e(),
                                            props.row.exType == 0 &&
                                            items == 2 &&
                                            _vm.parArray.indexOf(
                                              "approvalBtnCode"
                                            ) != -1 &&
                                            !(
                                              props.row.exType == "0" &&
                                              _vm.parArray.indexOf(
                                                "confirmReceiptCode"
                                              ) != -1 &&
                                              props.row.orderStatus != 2 &&
                                              items == 2
                                            )
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.approvalBtn(
                                                          props.row,
                                                          1
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 批准 ")]
                                                )
                                              : _vm._e(),
                                            props.row.exType == 0 &&
                                            items == 2 &&
                                            _vm.parArray.indexOf(
                                              "backReturning"
                                            ) != -1
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.approvalBtn(
                                                          props.row,
                                                          2
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 驳回 ")]
                                                )
                                              : _vm._e(),
                                            props.row.exType == 0 &&
                                            items == 3 &&
                                            _vm.parArray.indexOf(
                                              "returnNoCode"
                                            ) != -1
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.returnedCode(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 单号 ")]
                                                )
                                              : _vm._e(),
                                            props.row.exType == "0" &&
                                            _vm.parArray.indexOf(
                                              "confirmReceiptCode"
                                            ) != -1 &&
                                            props.row.orderStatus != 2 &&
                                            items == 2
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.confirmReceipt(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 确定收货 ")]
                                                )
                                              : _vm._e(),
                                            props.row.exType == 0 && items != 2
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.logistDetail(
                                                          props.row.parcelNumber
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 物流 ")]
                                                )
                                              : _vm._e(),
                                            props.row.exType == "0" &&
                                            props.row.type == "A" &&
                                            items == 4 &&
                                            _vm.parArray.indexOf(
                                              "closeRecoveryCode"
                                            ) != -1
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.closeRecovery(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 关闭 ")]
                                                )
                                              : _vm._e(),
                                            props.row.exType == "0" &&
                                            props.row.type == "X" &&
                                            items == 4 &&
                                            _vm.parArray.indexOf(
                                              "RecoveryCode"
                                            ) != -1
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.closeRecovery(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 恢复 ")]
                                                )
                                              : _vm._e(),
                                            props.row.exType == 1 &&
                                            items == 5 &&
                                            props.row.type == "A" &&
                                            _vm.parArray.indexOf(
                                              "returnCloseRecoveryCode"
                                            ) != -1
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.returnCloseRecovery(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 关闭 ")]
                                                )
                                              : _vm._e(),
                                            props.row.exType == 1 &&
                                            items == 5 &&
                                            props.row.type == "X" &&
                                            _vm.parArray.indexOf(
                                              "returnRecoveryCode"
                                            ) != -1
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.returnCloseRecovery(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 恢复 ")]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      }
                                    ),
                                    _vm.parArray.indexOf("detailCode") != -1
                                      ? _c(
                                          "p",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.todetail(
                                                  props.row,
                                                  2
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" 详情 ")]
                                        )
                                      : _vm._e(),
                                    (props.row.exType == 0 &&
                                      _vm.parArray.indexOf("polliingCode") !=
                                        -1 &&
                                      props.row.proInsId) ||
                                    (props.row.exType == 1 &&
                                      props.row.orderType == 1 &&
                                      _vm.parArray.indexOf("polliingCode") !=
                                        -1 &&
                                      props.row.proInsId)
                                      ? _c(
                                          "p",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.polliingClick(
                                                  props.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" 流程 ")]
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm.tabName == 1
                              ? _c(
                                  "div",
                                  { staticClass: "operation" },
                                  [
                                    _vm.parArray.indexOf("detailCode") != -1
                                      ? _c(
                                          "p",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.todetail(
                                                  props.row,
                                                  2
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" 详情 ")]
                                        )
                                      : _vm._e(),
                                    _vm._l(
                                      props.row.operatingStatus,
                                      function (items) {
                                        return _c(
                                          "div",
                                          {
                                            key: items,
                                            staticClass: "inlineDiv",
                                          },
                                          [
                                            _vm.parArray.indexOf(
                                              "returendeTrueCode"
                                            ) != -1 && items == 4
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.returningTrue(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 确认 ")]
                                                )
                                              : _vm._e(),
                                            props.row.type == "A" &&
                                            _vm.parArray.indexOf(
                                              "returnCloseRecoveryCode"
                                            ) != -1 &&
                                            items == 5
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.returnCloseRecovery(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 关闭 ")]
                                                )
                                              : _vm._e(),
                                            props.row.type == "X" &&
                                            _vm.parArray.indexOf(
                                              "returnRecoveryCode"
                                            ) != -1 &&
                                            items == 5
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.returnCloseRecovery(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 恢复 ")]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm.tabName == 3
                              ? _c(
                                  "div",
                                  { staticClass: "operation" },
                                  [
                                    _vm.parArray.indexOf("detailCode") != -1
                                      ? _c(
                                          "p",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.todetail(
                                                  props.row,
                                                  2
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" 详情 ")]
                                        )
                                      : _vm._e(),
                                    _vm.parArray.indexOf("polliingCode") !=
                                      -1 && props.row.proInsId
                                      ? _c(
                                          "p",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.polliingClick(
                                                  props.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" 流程 ")]
                                        )
                                      : _vm._e(),
                                    _vm._l(
                                      props.row.operatingStatus,
                                      function (items) {
                                        return _c(
                                          "div",
                                          {
                                            key: items,
                                            staticClass: "inlineDiv",
                                          },
                                          [
                                            _vm.parArray.indexOf("unFixCode") !=
                                              -1 && items == 1
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.todetail(
                                                          props.row,
                                                          1
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 修改 ")]
                                                )
                                              : _vm._e(),
                                            _vm.parArray.indexOf(
                                              "returendeTrueCode"
                                            ) != -1 &&
                                            items == 1 &&
                                            props.row.orderType == 1 &&
                                            props.row.exType == 1
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.staffTrue(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 确认 ")]
                                                )
                                              : _vm._e(),
                                            _vm.parArray.indexOf(
                                              "approvalBtnCode"
                                            ) != -1 && items == 3
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.approvalBtn(
                                                          props.row,
                                                          1
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 批准 ")]
                                                )
                                              : _vm._e(),
                                            _vm.parArray.indexOf(
                                              "backReturning"
                                            ) != -1 && items == 3
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.approvalBtn(
                                                          props.row,
                                                          2
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 驳回 ")]
                                                )
                                              : _vm._e(),
                                            props.row.type == "A" &&
                                            _vm.parArray.indexOf(
                                              "returnCloseRecoveryCode"
                                            ) != -1 &&
                                            items == 5
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.returnCloseRecovery(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 关闭 ")]
                                                )
                                              : _vm._e(),
                                            props.row.type == "X" &&
                                            _vm.parArray.indexOf(
                                              "returnRecoveryCode"
                                            ) != -1 &&
                                            items == 5
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.returnCloseRecovery(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 恢复 ")]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm.tabName == 2
                              ? _c(
                                  "div",
                                  { staticClass: "operation" },
                                  [
                                    _vm.parArray.indexOf("polliingCode") !=
                                      -1 && props.row.proInsId
                                      ? _c(
                                          "p",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.polliingClick(
                                                  props.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" 流程 ")]
                                        )
                                      : _vm._e(),
                                    _vm.parArray.indexOf("detailCode") != -1
                                      ? _c(
                                          "p",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.todetail(
                                                  props.row,
                                                  2
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" 详情 ")]
                                        )
                                      : _vm._e(),
                                    _vm._l(
                                      props.row.operatingStatus,
                                      function (items) {
                                        return _c(
                                          "div",
                                          {
                                            key: items,
                                            staticClass: "inlineDiv",
                                          },
                                          [
                                            _vm.parArray.indexOf(
                                              "approvalBtnCode"
                                            ) != -1 &&
                                            items == 2 &&
                                            !(
                                              _vm.parArray.indexOf(
                                                "confirmReceiptCode"
                                              ) != -1 &&
                                              items == 2 &&
                                              props.row.orderStatus != 2
                                            )
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.approvalBtn(
                                                          props.row,
                                                          1
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 批准 ")]
                                                )
                                              : _vm._e(),
                                            _vm.parArray.indexOf(
                                              "backReturning"
                                            ) != -1 && items == 2
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.approvalBtn(
                                                          props.row,
                                                          2
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 驳回 ")]
                                                )
                                              : _vm._e(),
                                            _vm.parArray.indexOf("unFixCode") !=
                                              -1 && items == 1
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.todetail(
                                                          props.row,
                                                          1
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 修改 ")]
                                                )
                                              : _vm._e(),
                                            _vm.parArray.indexOf(
                                              "returnNoCode"
                                            ) != -1 && items == 3
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.returnedCode(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 单号 ")]
                                                )
                                              : _vm._e(),
                                            _vm.parArray.indexOf(
                                              "confirmReceiptCode"
                                            ) != -1 &&
                                            items == 2 &&
                                            props.row.orderStatus != 2
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.confirmReceipt(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 确定收货 ")]
                                                )
                                              : _vm._e(),
                                            props.row.type == "A" &&
                                            _vm.parArray.indexOf(
                                              "closeRecoveryCode"
                                            ) != -1 &&
                                            items == 4
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.closeRecovery(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 关闭 ")]
                                                )
                                              : _vm._e(),
                                            props.row.type == "X" &&
                                            _vm.parArray.indexOf(
                                              "RecoveryCode"
                                            ) != -1 &&
                                            items == 4
                                              ? _c(
                                                  "p",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.closeRecovery(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 恢复 ")]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm.tabName == 5
                              ? _c("div", { staticClass: "operation" }, [
                                  props.row.exType == "0" &&
                                  props.row.type == "A" &&
                                  _vm.parArray.indexOf("closeRecoveryCode") !=
                                    -1
                                    ? _c(
                                        "p",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.closeRecovery(
                                                props.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" 关闭 ")]
                                      )
                                    : _vm._e(),
                                  props.row.exType == "0" &&
                                  props.row.type == "X" &&
                                  _vm.parArray.indexOf("RecoveryCode") != -1
                                    ? _c(
                                        "p",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.closeRecovery(
                                                props.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" 恢复 ")]
                                      )
                                    : _vm._e(),
                                  props.row.exType == 1 &&
                                  props.row.type == "A" &&
                                  _vm.parArray.indexOf(
                                    "returnCloseRecoveryCode"
                                  ) != -1
                                    ? _c(
                                        "p",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.returnCloseRecovery(
                                                props.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" 关闭 ")]
                                      )
                                    : _vm._e(),
                                  props.row.exType == 1 &&
                                  props.row.type == "X" &&
                                  _vm.parArray.indexOf("returnRecoveryCode") !=
                                    -1
                                    ? _c(
                                        "p",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.returnCloseRecovery(
                                                props.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" 恢复 ")]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            _vm.tabName == 4
                              ? _c("div", { staticClass: "operation" }, [
                                  _c(
                                    "p",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.todetail(props.row, 2)
                                        },
                                      },
                                    },
                                    [_vm._v("详情")]
                                  ),
                                  props.row.proInsId
                                    ? _c(
                                        "p",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.polliingClick(
                                                props.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" 流程 ")]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "p",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.logistDetail(
                                            props.row.parcelNumber
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("物流")]
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticStyle: { height: "40px" } }),
          _vm.tableData.totalNum > 0
            ? _c("div", { staticClass: "page" }, [
                _c(
                  "div",
                  { staticClass: "block" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.pageNO,
                        "page-sizes": [10, 20, 50, 100, 200],
                        "page-size": _vm.pageSize,
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.tableData.totalNum,
                        "prev-text": "上一页",
                        "next-text": "下一页",
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange,
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.logistFillin,
            "append-to-body": true,
            title: "提交退货单号填写",
          },
          on: {
            "update:visible": function ($event) {
              _vm.logistFillin = $event
            },
            close: function ($event) {
              _vm.logisticsCompany = ""
            },
          },
        },
        [
          _c("div", { staticClass: "fontTemp" }, [
            _c("p", [_c("span", [_vm._v("*")]), _vm._v("退货单号:")]),
            _c(
              "div",
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      placeholder: "快递公司",
                      filterable: "",
                      clearable: "",
                    },
                    model: {
                      value: _vm.logisticsCompany,
                      callback: function ($$v) {
                        _vm.logisticsCompany = $$v
                      },
                      expression: "logisticsCompany",
                    },
                  },
                  _vm._l(_vm.companys, function (itemsS) {
                    return _c("el-option", {
                      key: itemsS.dictName,
                      attrs: { label: itemsS.dictName, value: itemsS.dictName },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              [
                _c("el-input", {
                  attrs: { type: "text", placeholder: "请输入包裹物流单号" },
                  model: {
                    value: _vm.logistCode,
                    callback: function ($$v) {
                      _vm.logistCode = $$v
                    },
                    expression: "logistCode",
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.logistFillin = false
                      _vm.logistSumbit()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.logistFillin = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.ifapproval,
            "append-to-body": true,
            title: _vm.approvalTitle,
          },
          on: {
            "update:visible": function ($event) {
              _vm.ifapproval = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "text" },
            [
              _c("el-input", {
                attrs: { type: "textarea" },
                model: {
                  value: _vm.proposal,
                  callback: function ($$v) {
                    _vm.proposal = $$v
                  },
                  expression: "proposal",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.ifapproval = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm.result == 1
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.ifapproval = false
                          _vm.approvalHandle("1")
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
              _vm.result == 2
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.ifapproval = false
                          _vm.approvalHandle("1")
                        },
                      },
                    },
                    [_vm._v("驳回")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogFormPolliing,
            "append-to-body": true,
            title: "审核过程",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormPolliing = $event
            },
          },
        },
        [
          _c(
            "el-table",
            { staticStyle: { width: "100%" }, attrs: { data: _vm.polliing } },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "步骤", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "任务节点",
                  prop: "taskName",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: { label: "办理人", prop: "assignee", width: "110" },
              }),
              _c("el-table-column", {
                attrs: { label: "审批开始时间", prop: "startTime" },
              }),
              _c("el-table-column", {
                attrs: { label: "审批结束时间" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        !_vm.is_null(props.row.endTime)
                          ? _c("span", [_vm._v(_vm._s(props.row.endTime))])
                          : _vm._e(),
                        _vm.is_null(props.row.endTime)
                          ? _c("span", [_vm._v("正在处理中...")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "审批意见", "show-overflow-tooltip": true },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        !_vm.is_null(props.row.comment)
                          ? _c("span", [_vm._v(_vm._s(props.row.comment))])
                          : _vm._e(),
                        _vm.is_null(props.row.comment)
                          ? _c("span", [_vm._v("/")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.dialogFormPolliing = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.logisPoper,
            "append-to-body": true,
            title: "物流查询详情",
          },
          on: {
            "update:visible": function ($event) {
              _vm.logisPoper = $event
            },
          },
        },
        [
          _c(
            "p",
            { staticClass: "logHeader" },
            [
              _c(
                "el-image",
                {
                  attrs: { src: _vm.logistlist.logo, alt: "", fit: "contain" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "image-slot",
                      attrs: { slot: "error" },
                      slot: "error",
                    },
                    [_c("i", { staticClass: "el-icon-picture-outline" })]
                  ),
                ]
              ),
              _c("span", [_vm._v(_vm._s(_vm.logistlist.expTextName))]),
              _c("span", [_vm._v(_vm._s(_vm.logistlist.mailNo))]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "trackingNode" },
            [
              _c(
                "el-steps",
                { attrs: { direction: "vertical", active: 0 } },
                _vm._l(_vm.logistlist.data, function (pre, index) {
                  return _c("el-step", {
                    key: index,
                    staticClass: "stepSuc",
                    staticStyle: { "line-height": "25px" },
                    attrs: {
                      title: "审批人" + pre.context,
                      description: pre.time,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.staffIf,
            "append-to-body": true,
            title: "确定确认被退货中的订单",
          },
          on: {
            "update:visible": function ($event) {
              _vm.staffIf = $event
            },
          },
        },
        [
          _c("p", { staticClass: "fontTemp" }, [
            _vm._v("应退金额：" + _vm._s(_vm.row.shouldReturnMoney)),
          ]),
          _c("div", { staticClass: "fontTemp" }, [
            _c("p", [_c("span", [_vm._v("*")]), _vm._v("实退金额:")]),
            _c(
              "div",
              [
                _c("el-input", {
                  attrs: { type: "text", placeholder: "请输入实退金额" },
                  model: {
                    value: _vm.staffSalay,
                    callback: function ($$v) {
                      _vm.staffSalay = $$v
                    },
                    expression: "staffSalay",
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.staffIf = false
                      _vm.staffSalayEvent()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.staffIf = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }